import Vue from 'vue';
import Index from './guide.vue';
import 'babel-polyfill';
/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { Index },
  template: '<Index />'
});



// WEBPACK FOOTER //
// ./src/pages/guide/guide.js